import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  KeyboardFocusModule,
  LayoutModule,
  OutletModule,
  OutletRefModule,
  PageComponentModule,
  PageLayoutModule,
  PageSlotModule,
  PwaModule,
  RoutingModule,
  SeoModule,
  SkipLinkModule,
  StorefrontComponentModule,
} from 'haba-storefrontlib';
import { BaseCoreModule } from './base-core.module';

@NgModule({
  imports: [
    BaseCoreModule.forRoot(),
    RouterModule,
    OutletModule,
    OutletRefModule,
    PwaModule,
    PageLayoutModule,
    SeoModule,
    PageComponentModule.forRoot(),
    PageSlotModule,
    SkipLinkModule,
    KeyboardFocusModule,
    LayoutModule,
    RoutingModule.forRoot(),
    OutletModule.forRoot(),
    StorefrontComponentModule,
  ],
  exports: [LayoutModule, StorefrontComponentModule],
})
export class BaseStorefrontModule {}
